import { useEffect, useRef } from 'react';

// Baked into the JS bundle at build time via prebuild script
const MY_BUILD_TIME = process.env.REACT_APP_BUILD_TIME || '0';

export function useVersionCheck() {
  const serverBuildTime = useRef(null);

  const checkVersion = async () => {
    try {
      const res = await fetch(`/version.json?t=${Date.now()}`);
      if (!res.ok) return;
      const data = await res.json();
      if (!data.buildTime || data.buildTime === '0') return;

      // This JS bundle is stale — force a fresh page load with cache-busting URL
      // so the browser bypasses any cached index.html and loads the new bundle
      if (MY_BUILD_TIME !== '0' && MY_BUILD_TIME !== data.buildTime) {
        const url = new URL(window.location.href);
        url.searchParams.set('_v', data.buildTime);
        window.location.replace(url.toString());
        return;
      }

      // Tab was open during a deploy — reload silently on tab switch
      if (serverBuildTime.current !== null && serverBuildTime.current !== data.buildTime) {
        window.location.reload();
        return;
      }

      serverBuildTime.current = data.buildTime;
    } catch (_) {}
  };

  useEffect(() => {
    checkVersion();
    const onVisible = () => { if (document.visibilityState === 'visible') checkVersion(); };
    document.addEventListener('visibilitychange', onVisible);
    return () => document.removeEventListener('visibilitychange', onVisible);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
}
